import React from 'react';

/** Decorative cards for the wallet application loading state. */
export default function WalletApplyingIcon() {
  return (
    <svg
      className="wallet-summary__loading-icon"
      width="96"
      height="96"
      viewBox="0 0 96 96"
      aria-hidden="true"
    >
      <g className="wallet-summary__card wallet-summary__card--back">
        <rect
          x="12"
          y="28"
          width="73"
          height="49"
          rx="9"
          fill="#fff"
          stroke="#e5e5e5"
          strokeWidth="2"
        />
      </g>
      <g className="wallet-summary__card wallet-summary__card--front">
        <rect x="8" y="18" width="73" height="49" rx="9" fill="#ebd435" />
        <rect x="8" y="29" width="73" height="10" fill="#faed84" />
        <rect x="18" y="47" width="13" height="8" rx="2" fill="#fff4a4" />
      </g>
    </svg>
  );
}
